import Vue from "vue";
import Router from "vue-router";
import { xLocalStorage } from "@/core/services/xLocalStorage.service";

Vue.use(Router);

function manageRedirection() {
  const userUISettings = xLocalStorage.getParsed("userUISettings");

  return { name: userUISettings.defaultRouteName ?? "auth_login" };
}

var router = new Router({
  mode: "history",
  // If you have a route that is handled in XRoutableDialog and our route has meta with corresponding boolean in XRoutableDialog, it's name should be the same with corresponding boolean and ended with _route.
  routes: [
    {
      path: "/_pages",
      redirect: manageRedirection(),
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "temp",
          name: "pages_temp",
          component: () => import("@/view/pages/TempPage.vue")
        }
      ]
    },
    {
      path: "/_pages/services/login",
      component: () => import("@/view/pages/services/Login.vue"),
      meta: {
        query: {
          SSOUniqueID: "",
          ApiKey: ""
        }
      }
    },
    {
      path: "/_pages/dashboard",
      redirect: manageRedirection(),
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "management",
          name: "pages_dashboard_management",
          component: () =>
            import("@/view/pages/dashboards/DashboardManagement.vue")
        }
      ]
    },
    {
      path: "/_pages/maps_instant",
      redirect: manageRedirection(),
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "monitoring",
          name: "pages_monitoring_instant",
          component: () =>
            import("@/view/pages/monitorings/MonitoringIndex.vue")
        }
      ]
    },
    {
      path: "/_pages/maps_online",
      redirect: manageRedirection(),
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "monitoring",
          name: "pages_monitoring_current_state",
          component: () =>
            import("@/view/pages/monitorings/MonitoringIndex.vue")
        },
        {
          path: "route_reports",
          name: "pages_route_reports",
          beforeEnter(to, from, next) {
            // When we click on "نمایش مسیر حرکت" button in Monitoring's popup, we want to go to RouteReport
            // and select the vehicle, while we cannot use params in router-link without dynamic parameter
            // (dynamic parameter: vehicleId in "route_reports/:vehicleId" path),
            // we use the query property for filling the params and go to RouteReport with filled params
            if (to.query.vehicleId) {
              next({
                name: to.name,
                params: { vehicleId: +to.query.vehicleId }
              });
            } else {
              next();
            }
          },
          component: () =>
            import("@/view/pages/routeReports/RouteReportIndex.vue")
        },
        {
          path: "tracker",
          name: "pages_monitoring_tracker",
          component: () =>
            import("@/view/pages/monitorings/MonitoringIndex.vue")
        },
        {
          path: "arbaeen",
          name: "pages_monitoring_arbaeen",
          component: () =>
            import("@/view/pages/monitorings/MonitoringIndex.vue")
        },
        {
          path: "spatial_distribution",
          name: "pages_monitoring_spatial_distribution",
          component: () =>
            import("@/view/pages/monitorings/MonitoringIndex.vue")
        }
      ]
    },
    {
      path: "/_pages/data_entry",
      redirect: manageRedirection(),
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "tracker_stops",
          name: "pages_tracker_stops",
          component: () =>
            import("@/view/pages/trackerStops/TrackerStopIndex.vue"),
          children: [
            {
              path: ":trackerStopId/edit",
              name: "pages_tracker_stops_edit",
              meta: {
                editDialog_route: true
              }
            },
            {
              path: "create",
              name: "pages_tracker_stops_create",
              meta: {
                createDialog_route: true
              }
            }
          ]
        },
        {
          path: "visit_reports",
          name: "pages_visit_reports",
          component: () =>
            import("@/view/pages/visitReports/VisitReportIndex.vue"),
          children: [
            {
              path: ":visitReportId/edit",
              name: "pages_visit_reports_edit",
              meta: {
                editDialog_route: true
              }
            },
            {
              path: "create",
              name: "pages_visit_reports_create",
              meta: {
                createDialog_route: true
              }
            }
          ]
        },
        {
          path: "tracker_evaluations",
          name: "pages_tracker_evaluations",
          component: () =>
            import(
              "@/view/pages/trackerEvaluations/TrackerEvaluationIndex.vue"
            ),
          children: [
            {
              path: ":trackerEvaluationId/edit",
              name: "pages_tracker_evaluations_edit",
              meta: {
                editDialog_route: true
              }
            },
            {
              path: "create",
              name: "pages_tracker_evaluations_create",
              meta: {
                createDialog_route: true
              }
            }
          ]
        },
        {
          path: "machine_failure_reasons",
          name: "pages_machine_failure_reasons",
          component: () =>
            import(
              "@/view/pages/machineFailureReasons/MachineFailureReasonIndex.vue"
            ),
          children: [
            {
              path: ":machineFailureReasonId/edit",
              name: "pages_machine_failure_reasons_edit",
              meta: {
                editDialog_route: true
              }
            }
          ]
        },
        {
          path: "missions",
          name: "pages_missions",
          component: () => import("@/view/pages/missions/MissionIndex.vue"),
          children: [
            {
              path: ":missionId/edit",
              name: "pages_mission_edit",
              meta: {
                editDialog_route: true
              }
            },
            {
              path: "create",
              name: "pages_mission_create",
              meta: {
                createDialog_route: true
              }
            }
          ]
        },
        {
          path: "supportContracts",
          name: "pages_support_contracts",
          component: () =>
            import("@/view/pages/supportContracts/SupportContractIndex.vue"),
          children: [
            {
              path: ":contractId/edit",
              name: "pages_support_contracts_edit",
              meta: {
                editDialog_route: true
              }
            },
            {
              path: "create",
              name: "pages_support_contracts_create",
              meta: {
                createDialog_route: true
              }
            }
          ]
        },
        {
          path: "vehicles",
          name: "pages_vehicles",
          component: () => import("@/view/pages/vehicles/VehicleIndex.vue"),
          children: [
            {
              path: ":trackerId/edit",
              name: "pages_vehicles_edit",
              meta: {
                editDialog_route: true
              }
            },
            {
              path: "create",
              name: "pages_vehicles_create",
              meta: {
                createDialog_route: true
              }
            }
          ]
        },
        {
          path: "import_trackers",
          name: "pages_import_trackers",
          component: () =>
            import("@/view/pages/importTrackers/ImportTrackerIndex.vue")
        },
        {
          path: "companies",
          name: "pages_companies",
          component: () => import("@/view/pages/companies/CompanyIndex.vue"),
          children: [
            {
              path: ":companyId/edit",
              name: "pages_companies_edit",
              meta: {
                editDialog_route: true
              }
            },
            {
              path: "create",
              name: "pages_companies_create",
              meta: {
                createDialog_route: true
              }
            }
          ]
        },
        {
          path: "areas",
          name: "pages_areas",
          component: () => import("@/view/pages/areas/AreaIndex.vue"),
          children: [
            {
              path: ":geofenceId/edit",
              name: "pages_areas_edit",
              meta: {
                editDialog_route: true
              }
            },
            {
              path: "create",
              name: "pages_areas_create",
              meta: {
                createDialog_route: true
              }
            }
          ]
        }
      ]
    },
    {
      path: "/_pages/reports/:reportGroup",
      redirect: manageRedirection(),
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: ":reportName?",
          name: "pages_reports",
          component: () => import("@/view/pages/reports/ReportIndex.vue")
        }
      ]
    },
    {
      path: "/_pages/video_reports",
      redirect: manageRedirection(),
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "lastWeekVideos",
          name: "pages_reports_lastWeekVideos",
          component: () =>
            import("@/view/pages/videoReports/LastWeekVideoReportIndex.vue")
        },
        {
          path: "oldVideos",
          name: "pages_reports_oldVideos",
          component: () =>
            import("@/view/pages/videoReports/OldVideoReportIndex.vue")
        }
      ]
    },
    {
      path: "/_pages/basic_settings",
      redirect: manageRedirection(),
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "roles",
          name: "pages_roles",
          component: () => import("@/view/pages/roles/RoleIndex.vue"),
          children: [
            {
              path: ":roleId/edit",
              name: "pages_roles_edit",
              meta: {
                editDialog_route: true
              }
            },
            {
              path: "create",
              name: "pages_roles_create",
              meta: {
                createDialog_route: true
              }
            }
          ]
        },
        {
          path: "users",
          name: "pages_users",
          component: () => import("@/view/pages/users/UserIndex.vue"),
          children: [
            {
              path: ":userId/edit",
              name: "pages_users_edit",
              meta: {
                editDialog_route: true
              }
            },
            {
              path: "create",
              name: "pages_users_create",
              meta: {
                createDialog_route: true
              }
            },
            {
              path: ":userId/activityLog",
              name: "pages_users_activity-log",
              meta: {
                activityDialog_route: true
              }
            }
          ]
        },
        {
          path: "user_profiles",
          name: "pages_user_profiles",
          redirect: { name: "pages_user_profiles_changePassword" },
          component: () => import("@/view/pages/userProfiles/Profile.vue"),
          children: [
            {
              path: "change_password",
              name: "pages_user_profiles_changePassword",
              component: () =>
                import("@/view/pages/userProfiles/ChangePassword.vue")
            },
            {
              path: "sensor_usage",
              name: "pages_user_profiles_sensorUsage",
              component: () =>
                import("@/view/pages/userProfiles/SensorUsage.vue")
            },
            {
              path: "status_datetime",
              name: "pages_user_profiles_reportSettingChange",
              component: () =>
                import("@/view/pages/userProfiles/ReportSettingChange.vue")
            }
          ]
        }
      ]
    },
    {
      path: "/_errors",
      name: "errors",
      component: () => import("@/view/pages/errors/Error.vue"),
      children: [
        {
          path: "404",
          name: "errors_404",
          meta: {
            error: true
          },
          component: () => import("@/view/pages/errors/404.vue")
        }
      ]
    },
    {
      path: "/_auth",
      redirect: manageRedirection(),
      component: () => import("@/view/pages/auth/Login"),
      children: [
        {
          name: "auth_login",
          path: "login",
          component: () => import("@/view/pages/auth/Login")
        }
      ]
    },
    {
      path: "/",
      redirect: manageRedirection()
    },
    {
      // redirect to 404 route, when none of the above matches
      path: "/*",
      redirect: { name: "errors_404" }
    }
  ]
});

if (process.env.NODE_ENV === "development") {
  router.addRoute({
    path: "/",
    redirect: { name: "auth_login" }
  });
}

export default router;
